import type { ChatColorTheme } from '@oneToOne/shared/components/chat/theme/ChatThemeContext'
import { css } from 'twind/css'

export const chatHeaderTitle = css({
  paddingInlineStart: 'var(--spacing-8)',
  fontWeight: 'var(--font-bold)',
})

export const chatHeaderContainer = ({ theme }: { theme: ChatColorTheme }) =>
  css({
    borderBottom: `1px solid ${
      theme === 'light' ? 'var(--gray-4)' : 'var(--cool-gray-800)'
    }`,
    color: theme === 'light' ? 'var(--gray-9)' : 'var(--cool-gray-200)',
    background: theme === 'light' ? '#fff' : 'var(--cool-gray-1000)',
    height: '52px',
    padding: '0 var(--spacing-12)',
    // temp fix before we move to new chat header
    position: 'relative',
    zIndex: 1,
  })
